import Api from '../../../../lib/api';
export const UPDATE_SELCTED_ARC_BAR_CHART_DATA = "UPDATE_SELCTED_ARC_BAR_CHART_DATA";

export const updateBarChartOnArcHover= (data) => ({
    type: UPDATE_SELCTED_ARC_BAR_CHART_DATA,
    data
})










// WEBPACK FOOTER //
// ./components/profilePage/actions/recipientActions/budgetVsExpenseCharts.js